import { Node, mergeAttributes } from "@tiptap/core";

/**
 * Video node — renders a native <video controls> element with the given src.
 * Used for self-hosted videos uploaded via /api/uploads/video → /api/media/{id}.
 */
export const Video = Node.create({
  name: "video",
  group: "block",
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      poster: { default: null },
      controls: { default: true },
    };
  },

  parseHTML() {
    return [{ tag: "video[src]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "video",
      mergeAttributes(
        {
          controls: "controls",
          preload: "metadata",
          playsinline: "true",
          class: "gv-editor-video",
        },
        HTMLAttributes
      ),
    ];
  },

  addCommands() {
    return {
      setVideo:
        (attrs) =>
        ({ chain }) =>
          chain()
            .insertContent([
              { type: this.name, attrs },
              { type: "paragraph" },
            ])
            .focus()
            .run(),
    };
  },
});

export default Video;
